import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Component that validates secret path and redirects to admin
 * Used for easter egg admin access
 */
export default function SecretAdminRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const currentPath = location.pathname.substring(1); // Remove leading slash
    const secretPath = sessionStorage.getItem('admin_secret_path');
    
    // If current path matches the secret path, allow access and navigate to admin
    if (secretPath && currentPath === secretPath) {
      sessionStorage.setItem('admin_secret_access', 'true');
      navigate('/admin', { replace: true });
    } else {
      // Invalid path, redirect home
      navigate('/', { replace: true });
    }
  }, [location, navigate]);

  return null;
}
